import { useIsMobileMediaQuery } from '@ui/utils/hooks/is-mobile-media-query';
import { AdGridItem } from './ad-grid-item';
import { useAds } from './use-ads';
import {useAuth} from '@common/auth/use-auth';

interface AdGridItemProps {
  object: string;
  className?: string;
}
export function AdPageItem({object, className}: AdGridItemProps) {
  const isMobile = useIsMobileMediaQuery();
  const {getPermission} = useAuth();
  const hideImageAds = !!getPermission('ads.hide.image');
  const {data} = useAds({
    object: object,
    display: isMobile ? 'mobile' : 'desktop',
    enabled: !hideImageAds,
  });
  
  if (hideImageAds || !data) return null;
  
  return (
    <AdGridItem ad={data} className={className}></AdGridItem>
  );
}
